import axios from 'axios';

import {store} from './configureStore';


const instanceDjango = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    
});

export const getRequestDjango = (url, params = {}) => {
    return instanceDjango.get(
        url,
        {params: params},
        {
            headers: {
                Authorization: `Bearer  ${store.getState().Auth.authToken}`,
            }
        }
    )
};

export const postRequestDjango = (url, data, config={}) => {
    return instanceDjango.post(
        url,
        data,
        {
            headers: {
                Authorization: `Bearer  ${store.getState().Auth.authToken}`,
            },
            ...config
        }
    )
};

export const patchRequestDjango = (url, data, config={}) => {
    return instanceDjango.patch(
        url,
        data,
        {
            headers: {
                Authorization: `Bearer  ${store.getState().Auth.authToken}`,
            },
            ...config
        }
    )
};

